module.exports = __webpack_public_path__ + "img/EmpresaPersonImg.0e157fb.png";